export default __webpack_public_path__ + "static/media/movieDB.bc83da11.png";